import ThemeFeature from "./themeFeature";

class ScrollBackTop extends ThemeFeature {
    /**
     * Animated scroll to top button
     * @param {string} selector
     * @param {number} scrollOffset [scrollOffset=600]
     * @param {number} duration [duration=1200]
     */
    enable(selector = '.scroll-to-top-btn', scrollOffset = 600, duration = 1200) {
        const scrollBackTopElement = document.querySelector(selector);
        if (scrollBackTopElement) {
            document.addEventListener('scroll', () => {
                if (window.scrollY > scrollOffset) {
                    if (!scrollBackTopElement.classList.contains('visible')) {
                        scrollBackTopElement.classList.add('visible');
                    }
                } else {
                    if (scrollBackTopElement.classList.contains('visible')) {
                        scrollBackTopElement.classList.remove('visible');
                    }
                }
            });

            scrollBackTopElement.addEventListener('click', () => {
                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        }
    }
}

export default ScrollBackTop;
